<div id="dashboard" class="flex flex-col">
  <div class="flex flex-col justify-center sm:w-auto">
    <div class="mb-8 flex flex-col justify-center sm:w-auto">
      <div class="flex sm:justify-center text-3xl sm:text-40px sm:font-rhetorik-sans mt-6">Your Applications</div>
      <div class="flex sm:justify-center px-0 sm:px-20 text-gray-tricon text-xl sm:text-xl mt-2">Below please find your rental applications with Tricon.</div>
      <div *ngIf="activeApplicationConfirmation!=null" class="text-gray-tricon text-base">
        <p> {{ activeApplicationConfirmation }} </p>
      </div>
      <div *ngIf="showDefaultApplicationConfirmation==true" class="flex sm:justify-center rounded-lg px-4 py-2 sm:px-8 sm:max-w-50 sm:mx-auto sm:py-4 bg-landscape-light-orange text-black text-lg" style="border: 2px solid #FF3C00; margin-top: 16px;">
        <p>Thank you for submitting payment for your application fee and hold fee for  {{ selectedPropertyTitle }}.  Your application will now begin processing.   We will be in touch with you as soon as a decision has been made on your application. Should you have any questions, you may contact us at 844.874.2661.</p>
      </div>
      <div *ngIf="waitlist" class="mt-4 shadow-lg rounded-lg px-4 py-2 sm:px-8 sm:py-4 bg-waitlist-light-orange text-black sm:max-w-50 sm:mx-auto sm:justify-center text-lg" style="border: 2px solid #FF3C00; margin-top: 16px;">
        <p>
          <strong>Thank you for your interest in {{ selectedPropertyTitle }}.</strong>
        </p>
        <br>
        <p>This home is currently unavailable. It may not be ready yet for lease, or an application has already been submitted by another prospective resident. We've added you to the waitlist and will send you an email with next steps on how to apply as soon as the home becomes available again.</p>
        <br>
        <p>If you submitted your inquiry during business hours, a leasing consultant will be in touch with you shortly. Otherwise, you can expect to hear from us the following business day.</p>
        <br>
        <p><strong>Office Hours</strong></p>
        <p>Monday–Friday: 5:00 AM–6:00 PM PST</p>
        <p>Saturday & Sunday: 6:00 AM–2:30 PM PST</p>
        <br>
        <p><strong>Explore Other Available Homes</strong></p>
        <p>In the meantime, please feel free to explore other available homes at <a href="http://www.{{triconDomain}}.com/Find/">www.{{triconDomain}}.com/Find/</a></p>
      </div>
      <div *ngIf="background" class="flex sm:justify-center rounded-lg px-4 py-2 sm:px-8 sm:max-w-50 sm:mx-auto sm:py-4 bg-landscape-light-orange text-black text-lg" style="border: 2px solid #FF3C00; margin-top: 16px;">
        <p>Thank you for completing your portion of the rental application. Once {{PrimaryApplicantName}} pays the application and holding fee, we’ll begin processing your application. If you have any questions or need assistance, please contact us at 844.874.2661</p>
      </div>
      <div *ngIf="smartHomeLink!=null && smartHomeLink.length > 0" class="flex sm:justify-center text-gray-tricon text-2xl">
        <p><a href='{{ smartHomeLink }}'>Click here</a> to learn more about our smart home package offering.</p>
      </div>
    </div>
  </div>
  <div *ngIf="isLoading" class="flex justify-center">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
  <div *ngIf="!showApplicationTabs && !isLoading" class="sm:w-auto flex justify-center border-0">
    <div class="grid auto-rows-fr grid-cols-1 sm:grid-cols-3 sm:gap-8">
      <div *ngFor="let app of applications">
        <div *ngIf="app.PropViewCard != undefined && app.PropViewCard.sqft !== null" class="my-4 flex justify-center flex-col">
          <div>
            <img class="rounded w-full h-auto max-w-500px" src={{app.PropViewCard.thumb}} [ngStyle]="{ 'filter': app.Property.PropertyPhase === 'Sold' ? 'grayscale(100%)' : 'none' }" >
          </div>
          <div class="flex flex-row justify-between items-baseline">
            <div *ngIf="app.RentalAppStatus !== 'DRAFT' && app.RentalAppStatus !== 'WAIT LIST'" class="flex text-2xl font-bold items-baseline font-denim-regular">
              ${{app.RentAmount}} <span class="text-base text-gray-tricon ml-1">/mo</span>
            </div>
            <div *ngIf="app.RentalAppStatus === 'DRAFT' || app.RentalAppStatus === 'WAIT LIST'" class="flex text-2xl font-bold items-baseline font-denim-regular">
              ${{app.PropViewCard.rent}} <span class="text-base text-gray-tricon ml-1">/mo</span>
            </div>
            <div class="flex flex-row justify-evenly text-lg">
              <div class="flex text-black font-denim-regular">{{app.PropViewCard.beds}}<span class="text-gray-tricon mx-1">bd</span> <span class="text-gray-tricon">|</span></div>
              <div class="flex ml-1 text-black font-denim-regular">{{app.PropViewCard.baths}}<span class="text-gray-tricon mx-1">ba</span> <span class="text-gray-tricon"> |</span> </div>
              <div class="flex ml-1 text-black font-denim-regular">{{app.PropViewCard.sqft}}<span class="text-gray-tricon ml-1">sqft</span></div>
            </div>
          </div>
          <div class="text-2xl sm:text-lg  sm:font-denim-regular">
            {{app.Property.AddressLine1}} {{app.Property.City}}, {{app.Property.State}} {{app.PropViewCard.zip}}
          </div>
          <button *ngIf="app.Property.PropertyPhase !== 'Sold'" mat-flat-button color="accent" class="my-4 sm:text-base items-end" (click)="continueApplication(app)">{{app.RentalAppStatus}}</button>
          <button *ngIf="app.Property.PropertyPhase === 'Sold'" mat-flat-button color="accent" class="my-4 sm:text-base items-end" [disabled]="true">Not Available</button>
        </div>
        <div *ngIf="app.PropViewCard?.sqft === null && applications?.length > 1" class="pb-8 pt-4 h-full max-w-500px">
          <div class="grid grid-rows-85%-auto grid-cols-1 h-full">
            <div class="flex flex-col justify-between bg-white rounded shadow-sm">
              <div class="grid grid-rows-2 justify-items-center">
                <div class="text-3xl sm:text-40px text-center mt-4 sm:font-denim-medium">
                  {{app.Property.AddressLine1}}
                </div>
                <div class="text-gray-tricon text-2xl sm:text-3xl text-center sm:font-denim-regular">{{app.Property.City}}</div>
              </div>
            </div>
            <div class="flex justify-center items-end">
              <div class="w-full">
                <button *ngIf="app.Property.PropertyPhase !== 'Sold'" mat-flat-button color="primary" class=" sm:text-base w-full" (click)="continueApplication(app)">{{app.RentalAppStatus}}</button>
                <button *ngIf="app.Property.PropertyPhase === 'Sold'" mat-flat-button color="primary" class=" sm:text-base w-full" [disabled]="true">Not Available</button>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="app.PropViewCard?.sqft === null && applications?.length === 1" style="height: 480px;" class="pb-8 pt-4  max-w-500px">
          <div class="grid grid-rows-85%-auto grid-cols-1 h-full">
            <div class="flex flex-col justify-between bg-white rounded shadow-sm">
              <div class="grid grid-rows-2 justify-items-center">
                <div class="text-3xl sm:text-40px text-center mt-4 sm:font-denim-medium">
                  {{app.Property.AddressLine1}}
                </div>
                <div class="text-gray-tricon text-2xl sm:text-3xl text-center sm:font-denim-regular">{{app.Property.City}}</div>
              </div>
            </div>
            <div class="flex justify-center items-end">
              <div class="w-full">
                <button *ngIf="app.Property.PropertyPhase !== 'Sold'" mat-flat-button color="primary" class=" sm:text-base w-full" (click)="continueApplication(app)">{{app.RentalAppStatus}}</button>
                <button *ngIf="app.Property.PropertyPhase === 'Sold'" mat-flat-button color="primary" class=" sm:text-base w-full" [disabled]="true">Not Available</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="showApplicationTabs && !isLoading" class="sm:w-auto flex justify-center border-0">
    <mat-tab-group  mat-align-tabs="center" #applicationTabs selectedIndex="0">
      <mat-tab *ngIf="draftStatusApplications.length" dynamicHeight>
        <ng-template mat-tab-label>
          <span style="font-size:20px;" class=" font-denim-regular">Draft</span>
        </ng-template>
        <div class="grid auto-rows-fr grid-cols-1 sm:grid-cols-3 sm:gap-8">
          <div *ngFor="let app of draftStatusApplications">
            <div *ngIf="app.PropViewCard != undefined && app.PropViewCard.sqft !== null" class="my-4 flex justify-center flex-col">
              <div>
                <img class="rounded w-full h-auto max-w-500px" src={{app.PropViewCard.thumb}} [ngStyle]="{ 'filter': app.Property.PropertyPhase === 'Sold' ? 'grayscale(100%)' : 'none' }">
              </div>
                <div class="flex flex-row justify-between items-baseline">
                  <div *ngIf="app.RentalAppStatus !== 'DRAFT' && app.RentalAppStatus !== 'WAIT LIST'" class="flex text-2xl font-bold items-baseline font-denim-regular">
                    ${{app.RentAmount}} <span class="text-base text-gray-tricon ml-1">/mo</span>
                  </div>
                  <div *ngIf="app.RentalAppStatus === 'DRAFT' || app.RentalAppStatus === 'WAIT LIST'" class="flex text-2xl font-bold items-baseline font-denim-regular">
                    ${{app.PropViewCard.rent}} <span class="text-base text-gray-tricon ml-1">/mo</span>
                  </div>
                  <div class="flex flex-row justify-evenly text-lg">
                    <div class="flex text-black font-denim-regular">{{app.PropViewCard.beds}}<span class="text-gray-tricon mx-1">bd</span> <span class="text-gray-tricon">|</span></div>
                    <div class="flex ml-1 text-black font-denim-regular">{{app.PropViewCard.baths}}<span class="text-gray-tricon mx-1">ba</span> <span class="text-gray-tricon"> |</span> </div>
                    <div class="flex ml-1 text-black font-denim-regular">{{app.PropViewCard.sqft}}<span class="text-gray-tricon ml-1">sqft</span></div>
                  </div>
                </div>
                <div class="text-2xl sm:text-lg  sm:font-denim-regular">
                  {{app.Property.AddressLine1}} {{app.Property.City}}, {{app.Property.State}} {{app.PropViewCard.zip}}
                </div>
                <button *ngIf="app.Property.PropertyPhase !== 'Sold'" mat-flat-button color="accent" class="my-4 sm:text-base items-end" (click)="continueApplication(app)">{{app.RentalAppStatus}}</button>
                <button *ngIf="app.Property.PropertyPhase === 'Sold'" mat-flat-button color="accent" class="my-4 sm:text-base items-end" [disabled]="true">Not Available</button>
              </div>
              <div *ngIf="app.PropViewCard?.sqft === null && draftStatusApplications?.length > 1" class="pb-8 pt-4 h-full max-w-500px">
                <div class="grid grid-rows-85%-auto grid-cols-1 h-full">
                  <div class="flex flex-col justify-between bg-white rounded shadow-sm">
                    <div class="grid grid-rows-2 justify-items-center">
                      <div class="text-3xl sm:text-40px text-center mt-4 sm:font-denim-medium">
                        {{app.Property.AddressLine1}}
                      </div>
                      <div class="text-gray-tricon text-2xl sm:text-3xl text-center sm:font-denim-regular">{{app.Property.City}}</div>
                    </div>
                  </div>
                  <div class="flex justify-center items-end">
                    <div class="w-full">
                      <button *ngIf="app.Property.PropertyPhase !== 'Sold'" mat-flat-button color="primary" class=" sm:text-base w-full" (click)="continueApplication(app)">{{app.RentalAppStatus}}</button>
                      <button *ngIf="app.Property.PropertyPhase === 'Sold'" mat-flat-button color="primary" class=" sm:text-base w-full" [disabled]="true">Not Available</button>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="app.PropViewCard?.sqft === null && applications?.length === 1" style="height: 480px;" class="pb-8 pt-4  max-w-500px">
                <div class="grid grid-rows-85%-auto grid-cols-1 h-full">
                  <div class="flex flex-col justify-between bg-white rounded shadow-sm">
                    <div class="grid grid-rows-2 justify-items-center">
                      <div class="text-3xl sm:text-40px text-center mt-4 font-denim-regular">
                        {{app.Property.AddressLine1}}
                      </div>
                      <div class="text-gray-tricon text-2xl sm:text-3xl text-center font-denim-regular">{{app.Property.City}}</div>
                    </div>
                  </div>
                  <div class="flex justify-center items-end">
                    <div class="w-full">
                      <button *ngIf="app.Property.PropertyPhase !== 'Sold'" mat-flat-button color="primary" class=" sm:text-base w-full" (click)="continueApplication(app)">{{app.RentalAppStatus}}</button>
                      <button *ngIf="app.Property.PropertyPhase === 'Sold'" mat-flat-button color="primary" class=" sm:text-base w-full" [disabled]="true">Not Available</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </mat-tab>
      <mat-tab *ngIf="submittedStatusApplications.length" dynamicHeight>
        <ng-template mat-tab-label>
          <span style="font-size: 20px;" class=" font-denim-regular">Submitted</span>
        </ng-template>
        <div class="grid auto-rows-fr grid-cols-1 sm:grid-cols-3 sm:gap-8">
          <div *ngFor="let app of submittedStatusApplications">
            <div *ngIf="app.PropViewCard != undefined && app.PropViewCard.sqft !== null" class="my-4 flex justify-center flex-col">
              <div>
                <img class="rounded w-full h-auto max-w-500px" src={{app.PropViewCard.thumb}} [ngStyle]="{ 'filter': app.Property.PropertyPhase === 'Sold' ? 'grayscale(100%)' : 'none' }">
              </div>
                <div class="flex flex-row justify-between items-baseline">
                  <div *ngIf="app.RentalAppStatus !== 'DRAFT' && app.RentalAppStatus !== 'WAIT LIST'" class="flex text-2xl font-bold items-baseline font-denim-regular">
                    ${{app.RentAmount}} <span class="text-base text-gray-tricon ml-1">/mo</span>
                  </div>
                  <div *ngIf="app.RentalAppStatus === 'DRAFT' || app.RentalAppStatus === 'WAIT LIST'" class="flex text-2xl font-bold items-baseline font-denim-regular">
                    ${{app.PropViewCard.rent}} <span class="text-base text-gray-tricon ml-1">/mo</span>
                  </div>
                  <div class="flex flex-row justify-evenly text-lg">
                    <div class="flex text-black font-denim-regular">{{app.PropViewCard.beds}}<span class="text-gray-tricon mx-1">bd</span> <span class="text-gray-tricon">|</span></div>
                    <div class="flex ml-1 text-black font-denim-regular">{{app.PropViewCard.baths}}<span class="text-gray-tricon mx-1">ba</span> <span class="text-gray-tricon"> |</span> </div>
                    <div class="flex ml-1 text-black font-denim-regular">{{app.PropViewCard.sqft}}<span class="text-gray-tricon ml-1">sqft</span></div>
                  </div>
                </div>
                <div class="text-2xl sm:text-lg  font-denim-regular">
                  {{app.Property.AddressLine1}} {{app.Property.City}}, {{app.Property.State}} {{app.PropViewCard.zip}}
                </div>
                <button *ngIf="app.Property.PropertyPhase !== 'Sold'" mat-flat-button color="accent" class="my-4 sm:text-base items-end" (click)="continueApplication(app)">{{app.RentalAppStatus}}</button>
                <button *ngIf="app.Property.PropertyPhase === 'Sold'" mat-flat-button color="accent" class="my-4 sm:text-base items-end" [disabled]="true">Not Available</button>
              </div>
              <div *ngIf="app.PropViewCard?.sqft === null && submittedStatusApplications?.length > 1" class="pb-8 pt-4 h-full max-w-500px">
                <div class="grid grid-rows-85%-auto grid-cols-1 h-full">
                  <div class="flex flex-col justify-between bg-white rounded shadow-sm">
                    <div class="grid grid-rows-2 justify-items-center">
                      <div class="text-3xl sm:text-40px text-center mt-4 sm:font-denim-medium">
                        {{app.Property.AddressLine1}}
                      </div>
                      <div class="text-gray-tricon text-2xl sm:text-3xl text-center sm:font-denim-regular">{{app.Property.City}}</div>
                    </div>
                  </div>
                  <div class="flex justify-center items-end">
                    <div class="w-full">
                      <button *ngIf="app.Property.PropertyPhase !== 'Sold'" mat-flat-button color="primary" class=" sm:text-base w-full" (click)="continueApplication(app)">{{app.RentalAppStatus}}</button>
                      <button *ngIf="app.Property.PropertyPhase === 'Sold'" mat-flat-button color="primary" class=" sm:text-base w-full" [disabled]="true">Not Available</button>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="app.PropViewCard?.sqft === null && applications?.length === 1" style="height: 480px;" class="pb-8 pt-4  max-w-500px">
                <div class="grid grid-rows-85%-auto grid-cols-1 h-full">
                  <div class="flex flex-col justify-between bg-white rounded shadow-sm">
                    <div class="grid grid-rows-2 justify-items-center">
                      <div class="text-3xl sm:text-40px text-center mt-4 font-denim-regular">
                        {{app.Property.AddressLine1}}
                      </div>
                      <div class="text-gray-tricon text-2xl sm:text-3xl text-center font-denim-regular">{{app.Property.City}}</div>
                    </div>
                  </div>
                  <div class="flex justify-center items-end">
                    <div class="w-full">
                      <button *ngIf="app.Property.PropertyPhase !== 'Sold'" mat-flat-button color="primary" class=" sm:text-base w-full" (click)="continueApplication(app)">{{app.RentalAppStatus}}</button>
                      <button *ngIf="app.Property.PropertyPhase === 'Sold'" mat-flat-button color="primary" class=" sm:text-base w-full" [disabled]="true">Not Available</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </mat-tab>
      <mat-tab *ngIf="waitlistStatusApplications.length" dynamicHeight>
        <ng-template mat-tab-label>
          <span style="font-size: 20px;" class=" font-denim-regular">Waitlist</span>
        </ng-template>
        <div class="grid auto-rows-fr grid-cols-1 sm:grid-cols-3 sm:gap-8">
          <div *ngFor="let app of waitlistStatusApplications">
            <div *ngIf="app.PropViewCard != undefined && app.PropViewCard.sqft !== null" class="my-4 flex justify-center flex-col">
              <div>
                <img class="rounded w-full h-auto max-w-500px" src={{app.PropViewCard.thumb}} [ngStyle]="{ 'filter': app.Property.PropertyPhase === 'Sold' ? 'grayscale(100%)' : 'none' }">
              </div>
                <div class="flex flex-row justify-between items-baseline">
                  <div *ngIf="app.RentalAppStatus !== 'DRAFT' && app.RentalAppStatus !== 'WAIT LIST'" class="flex text-2xl font-bold items-baseline font-denim-regular">
                    ${{app.RentAmount}} <span class="text-base text-gray-tricon ml-1">/mo</span>
                  </div>
                  <div *ngIf="app.RentalAppStatus === 'DRAFT' || app.RentalAppStatus === 'WAIT LIST'" class="flex text-2xl font-bold items-baseline font-denim-regular">
                    ${{app.PropViewCard.rent}} <span class="text-base text-gray-tricon ml-1">/mo</span>
                  </div>
                  <div class="flex flex-row justify-evenly text-lg">
                    <div class="flex text-black font-denim-regular">{{app.PropViewCard.beds}}<span class="text-gray-tricon mx-1">bd</span> <span class="text-gray-tricon">|</span></div>
                    <div class="flex ml-1 text-black font-denim-regular">{{app.PropViewCard.baths}}<span class="text-gray-tricon mx-1">ba</span> <span class="text-gray-tricon"> |</span> </div>
                    <div class="flex ml-1 text-black font-denim-regular">{{app.PropViewCard.sqft}}<span class="text-gray-tricon ml-1">sqft</span></div>
                  </div>
                </div>
                <div class="text-2xl sm:text-lg  font-denim-regular">
                  {{app.Property.AddressLine1}} {{app.Property.City}}, {{app.Property.State}} {{app.PropViewCard.zip}}
                </div>
                <button *ngIf="app.Property.PropertyPhase !== 'Sold'" mat-flat-button color="accent" class="my-4 sm:text-base items-end" (click)="continueApplication(app)">{{app.RentalAppStatus}}</button>
                <button *ngIf="app.Property.PropertyPhase === 'Sold'" mat-flat-button color="accent" class="my-4 sm:text-base items-end" [disabled]="true">Not Available</button>
              </div>
              <div *ngIf="app.PropViewCard?.sqft === null && waitlistStatusApplications?.length > 1" class="pb-8 pt-4 h-full max-w-500px">
                <div class="grid grid-rows-85%-auto grid-cols-1 h-full">
                  <div class="flex flex-col justify-between bg-white rounded shadow-sm">
                    <div class="grid grid-rows-2 justify-items-center">
                      <div class="text-3xl sm:text-40px text-center mt-4 sm:font-denim-medium">
                        {{app.Property.AddressLine1}}
                      </div>
                      <div class="text-gray-tricon text-2xl sm:text-3xl text-center sm:font-denim-regular">{{app.Property.City}}</div>
                    </div>
                  </div>
                  <div class="flex justify-center items-end">
                    <div class="w-full">
                      <button *ngIf="app.Property.PropertyPhase !== 'Sold'" mat-flat-button color="primary" class=" sm:text-base w-full" (click)="continueApplication(app)">{{app.RentalAppStatus}}</button>
                      <button *ngIf="app.Property.PropertyPhase === 'Sold'" mat-flat-button color="primary" class=" sm:text-base w-full" [disabled]="true">Not Available</button>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="app.PropViewCard?.sqft === null && applications?.length === 1" style="height: 480px;" class="pb-8 pt-4  max-w-500px">
                <div class="grid grid-rows-85%-auto grid-cols-1 h-full">
                  <div class="flex flex-col justify-between bg-white rounded shadow-sm">
                    <div class="grid grid-rows-2 justify-items-center">
                      <div class="text-3xl sm:text-40px text-center mt-4 font-denim-regular">
                        {{app.Property.AddressLine1}}
                      </div>
                      <div class="text-gray-tricon text-2xl sm:text-3xl text-center font-denim-regular">{{app.Property.City}}</div>
                    </div>
                  </div>
                  <div class="flex justify-center items-end">
                    <div class="w-full">
                      <button *ngIf="app.Property.PropertyPhase !== 'Sold'" mat-flat-button color="primary" class=" sm:text-base w-full" (click)="continueApplication(app)">{{app.RentalAppStatus}}</button>
                      <button *ngIf="app.Property.PropertyPhase === 'Sold'" mat-flat-button color="primary" class=" sm:text-base w-full" [disabled]="true">Not Available</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </mat-tab>
      <mat-tab *ngIf="closedStatusApplications.length" dynamicHeight>
        <ng-template mat-tab-label>
          <span style="font-size: 20px;" class=" font-denim-regular">Closed</span>
        </ng-template>
        <div class="grid auto-rows-fr grid-cols-1 sm:grid-cols-3 sm:gap-8">
          <div *ngFor="let app of closedStatusApplications">
            <div *ngIf="app.PropViewCard != undefined && app.PropViewCard.sqft !== null" class="my-4 flex justify-center flex-col">
              <div>
                <img class="rounded w-full h-auto max-w-500px" src={{app.PropViewCard.thumb}} [ngStyle]="{ 'filter': app.Property.PropertyPhase === 'Sold' ? 'grayscale(100%)' : 'none' }">
              </div>
                <div class="flex flex-row justify-between items-baseline">
                  <div *ngIf="app.RentalAppStatus !== 'DRAFT' && app.RentalAppStatus !== 'WAIT LIST'" class="flex text-2xl font-bold items-baseline font-denim-regular">
                    ${{app.RentAmount}} <span class="text-base text-gray-tricon ml-1">/mo</span>
                  </div>
                  <div *ngIf="app.RentalAppStatus === 'DRAFT' || app.RentalAppStatus === 'WAIT LIST'" class="flex text-2xl font-bold items-baseline font-denim-regular">
                    ${{app.PropViewCard.rent}} <span class="text-base text-gray-tricon ml-1">/mo</span>
                  </div>
                  <div class="flex flex-row justify-evenly text-lg">
                    <div class="flex text-black font-denim-regular">{{app.PropViewCard.beds}}<span class="text-gray-tricon mx-1">bd</span> <span class="text-gray-tricon">|</span></div>
                    <div class="flex ml-1 text-black font-denim-regular">{{app.PropViewCard.baths}}<span class="text-gray-tricon mx-1">ba</span> <span class="text-gray-tricon"> |</span> </div>
                    <div class="flex ml-1 text-black font-denim-regular">{{app.PropViewCard.sqft}}<span class="text-gray-tricon ml-1">sqft</span></div>
                  </div>
                </div>
                <div class="text-2xl sm:text-lg  font-denim-regular">
                  {{app.Property.AddressLine1}} {{app.Property.City}}, {{app.Property.State}} {{app.PropViewCard.zip}}
                </div>
                <button *ngIf="app.Property.PropertyPhase !== 'Sold'" mat-flat-button color="accent" class="my-4 sm:text-base items-end" (click)="continueApplication(app)">{{app.RentalAppStatus}}</button>
                <button *ngIf="app.Property.PropertyPhase === 'Sold'" mat-flat-button color="accent" class="my-4 sm:text-base items-end" [disabled]="true">Not Available</button>
              </div>
              <div *ngIf="app.PropViewCard?.sqft === null && closedStatusApplications?.length > 1" class="pb-8 pt-4 h-full max-w-500px">
                <div class="grid grid-rows-85%-auto grid-cols-1 h-full">
                  <div class="flex flex-col justify-between bg-white rounded shadow-sm">
                    <div class="grid grid-rows-2 justify-items-center">
                      <div class="text-3xl sm:text-40px text-center mt-4 sm:font-denim-medium">
                        {{app.Property.AddressLine1}}
                      </div>
                      <div class="text-gray-tricon text-2xl sm:text-3xl text-center sm:font-denim-regular">{{app.Property.City}}</div>
                    </div>
                  </div>
                  <div class="flex justify-center items-end">
                    <div class="w-full">
                      <button *ngIf="app.Property.PropertyPhase !== 'Sold'" mat-flat-button color="primary" class=" sm:text-base w-full" (click)="continueApplication(app)">{{app.RentalAppStatus}}</button>
                      <button *ngIf="app.Property.PropertyPhase === 'Sold'" mat-flat-button color="primary" class=" sm:text-base w-full" [disabled]="true">Not Available</button>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="app.PropViewCard?.sqft === null && applications?.length === 1" style="height: 480px;" class="pb-8 pt-4  max-w-500px">
                <div class="grid grid-rows-85%-auto grid-cols-1 h-full">
                  <div class="flex flex-col justify-between bg-white rounded shadow-sm">
                    <div class="grid grid-rows-2 justify-items-center">
                      <div class="text-3xl sm:text-40px text-center mt-4 sm:font-denim-medium">
                        {{app.Property.AddressLine1}}
                      </div>
                      <div class="text-gray-tricon text-2xl sm:text-3xl text-center sm:font-denim-regular">{{app.Property.City}}</div>
                    </div>
                  </div>
                  <div class="flex justify-center items-end">
                    <div class="w-full">
                      <button *ngIf="app.Property.PropertyPhase !== 'Sold'" mat-flat-button color="primary" class=" sm:text-base w-full" (click)="continueApplication(app)">{{app.RentalAppStatus}}</button>
                      <button *ngIf="app.Property.PropertyPhase === 'Sold'" mat-flat-button color="primary" class=" sm:text-base w-full" [disabled]="true">Not Available</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
